export default __webpack_public_path__ + "static/media/counter-bg.0aaa0342.jpg";